import {
  AppealBooking,
  BookingApi,
  BookingV1BookingCreateRequest,
  BookingV1BookingListRequest,
  BookingV1ConsultationCreateRequest,
  InlineResponse2004,
  Deal,
  AppealConsultation,
  OwnershipTypesResponse,
  DealCreate,
  BookingV1DealCreateRequest,
  DealUpdate,
  BookingV1DealPartialUpdateRequest,
  PaymentTypesResponse,
  BookingV1DealOwnerListRequest,
  InlineResponse2007,
  BookingV1DealOwnerDocumentListRequest,
  InlineResponse2006,
  Owners,
  BookingV1DealOwnerCreateRequest,
  BookingV1DealOwnerDocumentCreateRequest,
  Document,
  BookingV1DealOwnerDeleteRequest,
  BookingV1DealOwnerDocumentDeleteRequest,
  ChangeOwner,
  BookingV1DealOwnerPartialUpdateRequest,
  BookingV1DealOwnerDocumentPartialUpdateRequest,
  DocumentChange,
  BookingV1DealNoteCreateRequest,
  Note,
  BookingV1ContractDateCreateRequest,
  BookingV1DealDocumentCreateRequest,
  BookingV1DealDocumentDeleteRequest,
  BookingV1DealDocumentPartialUpdateRequest,
  BookingV1DealDocumentListRequest,
  MortgageRequest,
} from '@/requests/mainApi';
import { IResponse, requestMachine } from '@/requests/requestMachine';

export default {
  getBookingFlat(variables: BookingV1BookingListRequest): Promise<IResponse<InlineResponse2004>> {
    return requestMachine<InlineResponse2004, BookingV1BookingListRequest>(
      BookingApi,
      'bookingV1BookingList',
      true,
      variables
    );
  },
  updateBookingFlat(variables: BookingV1BookingCreateRequest): Promise<IResponse<AppealBooking>> {
    return requestMachine<AppealBooking, BookingV1BookingCreateRequest>(
      BookingApi,
      'bookingV1BookingCreate',
      true,
      variables
    );
  },
  sendConsultationRequest(variables: BookingV1ConsultationCreateRequest): Promise<IResponse<AppealConsultation>> {
    return requestMachine<AppealConsultation, BookingV1ConsultationCreateRequest>(
      BookingApi,
      'bookingV1ConsultationCreate',
      true,
      variables
    );
  },
  getDeal(): Promise<IResponse<Deal>> {
    return requestMachine<Deal>(BookingApi, 'bookingV1DealRead', true);
  },
  createDeal(variables: BookingV1DealCreateRequest): Promise<IResponse<DealCreate>> {
    return requestMachine<DealCreate, BookingV1DealCreateRequest>(BookingApi, 'bookingV1DealCreate', true, variables);
  },
  updateDeal(variables: BookingV1DealPartialUpdateRequest): Promise<IResponse<DealUpdate>> {
    return requestMachine<DealUpdate, BookingV1DealPartialUpdateRequest>(
      BookingApi,
      'bookingV1DealPartialUpdate',
      true,
      variables
    );
  },
  getOwnershipsList(): Promise<IResponse<OwnershipTypesResponse[]>> {
    return requestMachine<OwnershipTypesResponse[]>(BookingApi, 'bookingV1OwnershipList', true);
  },
  getOwnerList(variables: BookingV1DealOwnerListRequest): Promise<IResponse<InlineResponse2007>> {
    return requestMachine<InlineResponse2007, BookingV1DealOwnerListRequest>(
      BookingApi,
      'bookingV1DealOwnerList',
      true,
      variables
    );
  },
  createOwner(variables: BookingV1DealOwnerCreateRequest): Promise<IResponse<Owners>> {
    return requestMachine<Owners, BookingV1DealOwnerCreateRequest>(
      BookingApi,
      'bookingV1DealOwnerCreate',
      true,
      variables
    );
  },
  updateOwner(variables: BookingV1DealOwnerPartialUpdateRequest): Promise<IResponse<ChangeOwner>> {
    return requestMachine<ChangeOwner, BookingV1DealOwnerPartialUpdateRequest>(
      BookingApi,
      'bookingV1DealOwnerPartialUpdate',
      true,
      variables
    );
  },
  deleteOwner(variables: BookingV1DealOwnerDeleteRequest): Promise<IResponse<void>> {
    return requestMachine<void, BookingV1DealOwnerDeleteRequest>(
      BookingApi,
      'bookingV1DealOwnerDelete',
      true,
      variables
    );
  },
  getOwnerDocumentList(variables: BookingV1DealOwnerDocumentListRequest): Promise<IResponse<InlineResponse2006>> {
    return requestMachine<InlineResponse2006, BookingV1DealOwnerDocumentListRequest>(
      BookingApi,
      'bookingV1DealOwnerDocumentList',
      true,
      variables
    );
  },
  createOwnerDocuments(variables: BookingV1DealOwnerDocumentCreateRequest): Promise<IResponse<Document>> {
    return requestMachine<Document, BookingV1DealOwnerDocumentCreateRequest>(
      BookingApi,
      'bookingV1DealOwnerDocumentCreate',
      true,
      variables
    );
  },
  updateOwnerDocuments(variables: BookingV1DealOwnerDocumentPartialUpdateRequest): Promise<IResponse<DocumentChange>> {
    return requestMachine<DocumentChange, BookingV1DealOwnerDocumentPartialUpdateRequest>(
      BookingApi,
      'bookingV1DealOwnerDocumentPartialUpdate',
      true,
      variables
    );
  },
  deleteOwnerDocuments(variables: BookingV1DealOwnerDocumentDeleteRequest): Promise<IResponse<void>> {
    return requestMachine<void, BookingV1DealOwnerDocumentDeleteRequest>(
      BookingApi,
      'bookingV1DealOwnerDocumentDelete',
      true,
      variables
    );
  },
  sendOwnersToAmo(): Promise<IResponse<void>> {
    return requestMachine<void>(BookingApi, 'bookingV1OwnershipSendList', true);
  },
  getPaymentDetails(): Promise<IResponse<PaymentTypesResponse>> {
    return requestMachine<PaymentTypesResponse>(BookingApi, 'bookingV1PaymentList', true);
  },
  getPaymentDocuments(variables: BookingV1DealDocumentListRequest): Promise<IResponse<InlineResponse2006>> {
    return requestMachine<InlineResponse2006, BookingV1DealDocumentListRequest>(
      BookingApi,
      'bookingV1DealDocumentList',
      true,
      variables
    );
  },
  createPaymentDocuments(variables: BookingV1DealDocumentCreateRequest): Promise<IResponse<Document>> {
    return requestMachine<Document, BookingV1DealDocumentCreateRequest>(
      BookingApi,
      'bookingV1DealDocumentCreate',
      true,
      variables
    );
  },
  updatePaymentDocuments(variables: BookingV1DealDocumentPartialUpdateRequest): Promise<IResponse<DocumentChange>> {
    return requestMachine<DocumentChange, BookingV1DealDocumentPartialUpdateRequest>(
      BookingApi,
      'bookingV1DealDocumentPartialUpdate',
      true,
      variables
    );
  },
  deletePaymentDocuments(variables: BookingV1DealDocumentDeleteRequest): Promise<IResponse<DocumentChange>> {
    return requestMachine<DocumentChange, BookingV1DealDocumentDeleteRequest>(
      BookingApi,
      'bookingV1DealDocumentDelete',
      true,
      variables
    );
  },
  sendPaymentDetails(): Promise<IResponse<void>> {
    return requestMachine<void>(BookingApi, 'bookingV1DealSendList', true);
  },
  getContract(): Promise<IResponse<Blob>> {
    return requestMachine<Blob>(BookingApi, 'bookingV1ContractList', true);
  },
  commentOnContract(variables: BookingV1DealNoteCreateRequest): Promise<IResponse<Deal>> {
    return requestMachine<Deal, BookingV1DealNoteCreateRequest>(BookingApi, 'bookingV1DealNoteCreate', true, variables);
  },
  agreeOnContract(): Promise<IResponse<void>> {
    return requestMachine<void>(BookingApi, 'bookingV1ContractAgreedList', true);
  },
  sendTypeOfSigning(variables: BookingV1ContractDateCreateRequest): Promise<IResponse<void>> {
    return requestMachine<void, BookingV1ContractDateCreateRequest>(
      BookingApi,
      'bookingV1ContractDateCreate',
      true,
      variables
    );
  },
  tryFinishDeal(): Promise<IResponse<Deal>> {
    return requestMachine<Deal>(BookingApi, 'bookingV1DealFinishRead', true);
  },
  createMortgageOrder(variables: MortgageRequest): Promise<IResponse<{ link: string }>> {
    return requestMachine<{ link: string }, MortgageRequest>(BookingApi, 'createMortgageOrder', true, variables);
  },
};
